import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { error } from 'actions/notifications';
import { DEFAULT_END_HOUR, DEFAULT_START_HOUR } from 'utils/hourFilter';
import styles from './ApplyBox.css';

class ApplyBox extends React.Component {
  constructor(props) {
    super(props);
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
      showModalCustomTime,
    } = this.props;
    this.state = {
      startDate: moment(startDate),
      endDate: moment(endDate),
      startDateText: moment(startDate).format('D/M/YY'),
      endDateText: moment(endDate).format('D/M/YY'),
      startHour,
      endHour,
      allDay: showModalCustomTime && allDay, // use props allDay as initial state for Custom Time so that it use the latest updated state from calendar
    };
  }

  componentWillReceiveProps(props) {
    const isSameStartDate = moment(props.startDate).isSame(
      this.state.startDate,
      'days'
    );
    const isSameEndDate = moment(props.endDate).isSame(
      this.state.endDate,
      'days'
    );
    if (
      props.startDate &&
      props.endDate &&
      !(isSameEndDate && isSameStartDate)
    ) {
      this.setState({
        startDate: moment(props.startDate),
        endDate: moment(props.endDate),
        startDateText: moment(props.startDate).format('D/M/YY'),
        endDateText: moment(props.endDate).format('D/M/YY'),
        startHour: props.startHour,
        endHour: props.endHour,
        allDay: props.allDay,
      });
    }
  }

  render() {
    const { showModalCustomTime } = this.props;

    return (
      <div className={showModalCustomTime ? '' : styles.wrapper}>
        {!showModalCustomTime && (
          <div className="row">
            <div className="col-md-12">
              <form>
                <div className={`${styles['form-group']} ${styles['all-day']}`}>
                  All day
                  <label className={styles.switch}>
                    {this.props.allDay ? (
                      <input
                        className={styles['switch-all-day']}
                        type="checkbox"
                        checked
                      />
                    ) : (
                      <input
                        className={styles['switch-all-day']}
                        type="checkbox"
                      />
                    )}
                    <span
                      className={`${styles.slider} ${styles.round}`}
                      onClick={this._onChangeAllDay}
                    />
                  </label>
                </div>
                <div
                  className={`${styles['form-group']} ${styles['start-date']}`}
                >
                  <span className={styles['label-start']}>Starts</span>
                  <input
                    type="text"
                    className={`form-control ${styles.input}`}
                    onChange={this._onChangeStartDate}
                    value={this.state.startDateText}
                  />
                </div>
                {!this.props.allDay && (
                  <div
                    className={`${styles['form-group']} ${
                      styles['start-hour']
                    }`}
                  >
                    <div className="input-group">
                      <input
                        type="text"
                        className={`form-control ${styles['input-hour']}`}
                        value={this.state.startHour}
                        onChange={this._onChangeStartHour}
                        maxLength="5"
                      />
                      <div className={`input-group-addon ${styles.addon}`}>
                        <a className={styles['spin-up']}>
                          <i
                            className="fa fa-caret-up"
                            onClick={this._onClickStartHourUp}
                          />
                        </a>
                        <a className={styles['spin-down']}>
                          <i
                            className="fa fa-caret-down"
                            onClick={this._onClickStartHourDown}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`${styles['form-group']} ${styles['end-date']}`}
                >
                  <span className={styles['label-end']}>Ends</span>
                  <input
                    type="text"
                    className={`form-control ${styles.input}`}
                    onChange={this._onChangeEndDate}
                    value={this.state.endDateText}
                  />
                </div>
                {!this.props.allDay && (
                  <div
                    className={`${styles['form-group']} ${styles['end-hour']}`}
                  >
                    <div className="input-group">
                      <input
                        type="text"
                        className={`form-control ${styles['input-hour']}`}
                        value={this.state.endHour}
                        onChange={this._onChangeEndHour}
                        maxLength="5"
                      />
                      <div className={`input-group-addon ${styles.addon}`}>
                        <a className={styles['spin-up']}>
                          <i
                            className="fa fa-caret-up"
                            onClick={this._onClickEndHourUp}
                          />
                        </a>
                        <a className={styles['spin-down']}>
                          <i
                            className="fa fa-caret-down"
                            onClick={this._onClickEndHourDown}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                <div className={`${styles['form-group']}`}>
                  <button
                    className={`btn btn-primary btn-block ${
                      this.state.allDay
                        ? styles['btn-apply']
                        : styles['btn-apply-hour']
                    }`}
                    onClick={this._onClickApply}
                  >
                    Apply
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showModalCustomTime && (
          <div>
            <div className="col-xs-2 col-sm-2 col-md-2">
              <i className="fa fa-calendar" />
            </div>
            <div className="col-xs-10 col-sm-10 col-md-10">
              <form>
                <div className={`${styles['btn-apply-custom']}`}>
                  <button
                    className={`btn btn-primary`}
                    onClick={this._onClickApply}
                  >
                    Apply
                  </button>
                </div>
                <div
                  className={`${styles['form-group']} ${
                    styles['all-day-custom']
                  }`}
                >
                  All day
                  <label className={styles.switch}>
                    <input
                      className={styles['switch-all-day']}
                      type="checkbox"
                      checked={this.state.allDay}
                      onChange={this._onChangeAllDay}
                    />
                    <span className={`${styles.slider} ${styles.round}`} />
                  </label>
                </div>

                <div
                  className={`${styles['form-group']} ${styles['start-date']}`}
                >
                  <span className={styles['mr-start']}>Starts</span>
                  <input
                    type="text"
                    className={`form-control ${styles.input} ${
                      styles['start-hour-custom']
                    }`}
                    onChange={this._onChangeStartDate}
                    value={this.state.startDateText}
                  />
                  {!this.props.allDay && (
                    <div className="input-group">
                      <input
                        type="text"
                        className={`form-control ${styles['input-hour']}`}
                        value={this.state.startHour}
                        onChange={this._onChangeStartHour}
                        maxLength="5"
                      />
                      <div className={`input-group-addon ${styles.addon}`}>
                        <a className={styles['spin-up']}>
                          <i
                            className="fa fa-caret-up"
                            onClick={this._onClickStartHourUp}
                          />
                        </a>
                        <a className={styles['spin-down']}>
                          <i
                            className="fa fa-caret-down"
                            onClick={this._onClickStartHourDown}
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className={`${styles['form-group']} ${styles['end-date']}`}
                >
                  <span className={styles['mr-end']}>Ends</span>
                  <input
                    type="text"
                    className={`form-control ${styles.input} ${
                      styles['end-hour-custom']
                    }`}
                    onChange={this._onChangeEndDate}
                    value={this.state.endDateText}
                  />
                  {!this.props.allDay && (
                    <div className="input-group">
                      <input
                        type="text"
                        className={`form-control ${styles['input-hour']}`}
                        value={this.state.endHour}
                        onChange={this._onChangeEndHour}
                        maxLength="5"
                      />
                      <div className={`input-group-addon ${styles.addon}`}>
                        <a className={styles['spin-up']}>
                          <i
                            className="fa fa-caret-up"
                            onClick={this._onClickEndHourUp}
                          />
                        </a>
                        <a className={styles['spin-down']}>
                          <i
                            className="fa fa-caret-down"
                            onClick={this._onClickEndHourDown}
                          />
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  }

  _onChangeStartDate = e => {
    let { value } = e.target;
    const splitText = value.split('/');
    const dateText = `${moment(this.state.startDate, 'YYYY-MM-DD')
      .year()
      .toString()
      .slice(0, 2)}${splitText[2]}-${splitText[1]}-${splitText[0]}`;
    if (
      moment(moment(dateText).format('YYYY-MM-DD')).isAfter(
        moment().format('YYYY-MM-DD')
      )
    ) {
      value = moment().format('D/M/YY');
    }
    this.setState({ startDateText: value });
  };

  _onChangeEndDate = e => {
    let { value } = e.target;
    const splitText = value.split('/');
    const dateText = `${moment(this.state.endDate, 'YYYY-MM-DD')
      .year()
      .toString()
      .slice(0, 2)}${splitText[2]}-${splitText[1]}-${splitText[0]}`;
    if (
      moment(moment(dateText).format('YYYY-MM-DD')).isAfter(
        moment().format('YYYY-MM-DD')
      )
    ) {
      value = moment().format('D/M/YY');
    }
    this.setState({ endDateText: value });
  };

  _onClickApply = e => {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onApply)
    e.preventDefault();
    e.stopPropagation();

    const { dispatch, showModalCustomTime } = this.props;
    const {
      startDateText,
      endDateText,
      startHour,
      endHour,
      allDay,
    } = this.state;
    const startDate = moment(startDateText, 'D/M/YY');
    const endDate = moment(endDateText, 'D/M/YY');

    // required to display timezone
    let endDateMessage = '';
    if (!allDay) {
      const formattedEndDateText = moment(endDate).format('MM D YYYY');
      endDateMessage = new Date(`${formattedEndDateText} ${endHour}:00`);
    } else {
      const formattedEndDateText = moment(endDate).format('D/M/YYYY');
      endDateMessage = new Date(
        formattedEndDateText.split('/')[2],
        formattedEndDateText.split('/')[1] - 1,
        formattedEndDateText.split('/')[0]
      );
    }
    const currentDateMessage = new Date();

    // To handle https://mokapos.atlassian.net/browse/OA-205
    if (showModalCustomTime) {
      this.props.closeCustomTime();
    }

    if (!startDate.isValid()) {
      dispatch(error('Invalid start date. Format must be D/M/YYYY'));
    } else if (!endDate.isValid()) {
      dispatch(error('Invalid end date. Format must be D/M/YYYY'));
    } else if (startDate.isAfter(endDate, 'days')) {
      dispatch(
        error(
          `Start date should be lower than equal end date (${endDateMessage.toString()})`
        )
      );
    } else if (startDate.isAfter(moment(), 'days')) {
      dispatch(
        error(
          `Start date should be lower than equal current date (${currentDateMessage.toString()})`
        )
      );
    } else if (Math.abs(startDate.diff(endDate, 'days')) > 365) {
      dispatch(error('Reports can only be shown for one year period or less'));
    } else if (
      !allDay &&
      startDate.isSame(endDate, 'days') &&
      startHour > endHour
    ) {
      dispatch(
        error(
          `Start time should be lower than equal end time (${endDateMessage.toString()})`
        )
      );
    } else if (
      !moment(`${startDateText} ${startHour}`, 'D/M/YY HH:mm', true).isValid()
    ) {
      dispatch(error('Invalid start time. Format must be HH:MM'));
    } else if (
      !moment(`${endDateText} ${endHour}`, 'D/M/YY HH:mm', true).isValid()
    ) {
      dispatch(error('Invalid end time. Format must be HH:MM'));
    } else {
      this.props.onApply({ startDate, endDate, startHour, endHour, allDay });
    }
  };

  _onChangeStartHour = e => {
    let { value } = e.target;
    const [hour, minute] = value.split(':');

    if (minute !== '00') {
      value = `${hour}:00`;
    } else if (hour > 23) {
      value = '23:00';
    } else if (hour < 0) {
      value = '00:00';
    }
    this.setState({ startHour: value });
  };

  _onChangeEndHour = e => {
    let { value } = e.target;
    const [hour, minute] = value.split(':');

    if (minute !== '00') {
      value = `${hour}:00`;
    } else if (hour > 23) {
      value = '23:00';
    } else if (hour < 0) {
      value = '00:00';
    }
    this.setState({ endHour: value });
  };

  _onClickStartHourUp = () => {
    const { startHour } = this.state;
    const counter = parseInt(startHour[0] + startHour[1]);
    if (counter < 23) {
      if (counter < 9) {
        this.setState({ startHour: `0${counter + 1}:00` });
      } else {
        this.setState({ startHour: `${counter + 1}:00` });
      }
    } else if (
      moment(moment(this.state.startDate).format('YYYY-MM-DD')).isBefore(
        moment().format('YYYY-MM-DD')
      )
    ) {
      // start date cannot more than date today
      this.setState({ startHour: '00:00' });
      const startDate = this.props.startDate.startOf('day').add(+1, 'days');
      this.setState({ startDate });
      this.setState({ startDateText: moment(startDate).format('D/M/YY') });
    }
  };

  _onClickStartHourDown = () => {
    const { startHour } = this.state;
    const counter = parseInt(startHour[0] + startHour[1]);
    if (counter === 0) {
      this.setState({ startHour: '23:00' });
      const startDate = this.props.startDate.startOf('day').add(-1, 'days');
      this.setState({ startDate });
      this.setState({ startDateText: moment(startDate).format('D/M/YY') });
    } else if (counter < 11) {
      this.setState({ startHour: `0${counter - 1}:00` });
    } else {
      this.setState({ startHour: `${counter - 1}:00` });
    }
  };

  _onClickEndHourUp = () => {
    const { endHour } = this.state;
    const counter = parseInt(endHour[0] + endHour[1]);
    if (counter < 23) {
      if (counter < 9) {
        this.setState({ endHour: `0${counter + 1}:00` });
      } else {
        this.setState({ endHour: `${counter + 1}:00` });
      }
    } else if (
      moment(moment(this.state.endDate).format('YYYY-MM-DD')).isBefore(
        moment().format('YYYY-MM-DD')
      )
    ) {
      // end date can not more than date today
      this.setState({ endHour: '00:00' });
      const endDate = this.props.endDate.startOf('day').add(+1, 'days');
      this.setState({ endDate });
      this.setState({ endDateText: moment(endDate).format('D/M/YY') });
    }
  };

  _onClickEndHourDown = () => {
    const { endHour } = this.state;
    const counter = parseInt(endHour[0] + endHour[1]);
    if (counter === 0) {
      this.setState({ endHour: '23:00' });
      const endDate = this.props.endDate.startOf('day').add(-1, 'days');
      this.setState({ endDate });
      this.setState({ endDateText: moment(endDate).format('D/M/YY') });
    } else if (counter < 11) {
      this.setState({ endHour: `0${counter - 1}:00` });
    } else {
      this.setState({ endHour: `${counter - 1}:00` });
    }
  };

  _onChangeAllDay = () => {
    const { prevStartHour, prevEndHour, prevAllDay } = this.props;
    this.setState({ allDay: !this.state.allDay });

    // To handle https://mokapos.atlassian.net/browse/CORE-2715
    this.props.setAllDayCalendar({ allDay: !this.state.allDay });

    if (!prevAllDay) {
      if (
        prevStartHour !== this.state.startHour ||
        prevEndHour !== this.state.endHour
      ) {
        this.setState({ startHour: prevStartHour });
        this.setState({ endHour: prevEndHour });
      }
    } else {
      this.setState({ startHour: DEFAULT_START_HOUR });
      this.setState({ endHour: DEFAULT_END_HOUR });
    }
  };
}

ApplyBox.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onApply: PropTypes.func,
  startHour: PropTypes.string,
  endHour: PropTypes.string,
  allDay: PropTypes.bool,
  setAllDayCalendar: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  null,
  mapDispatchToProps
)(ApplyBox);
